import CertificationsContainer from './certifications_container';

const Certifications = CertificationsContainer;
export default Certifications;
